// extracted by mini-css-extract-plugin
export default {"container":"simpleCard_container__vn9UY","row":"simpleCard_row__j68Rb","title":"simpleCard_title__WJuH+","value":"simpleCard_value__FnXrS"};